import * as svg from "../../../assets/check-icon.svg";

import {iconBuilder} from "./iconBuilder";

export const CheckIcon = iconBuilder(svg, "CheckIcon", "0 0 16 16");
